import React from 'react';
import { StyleSheet, View, ViewStyle } from 'react-native';
import Svg, { Defs, LinearGradient, Rect, Stop } from 'react-native-svg';

import { useSvgId } from '../../../utils/hooks/useSvgId';
import { eventColors, eventGlow, PANEL_FILL } from './eventTheme';

type Props = {
	children: React.ReactNode;
	/** Corner radius in viewport px - the caller has already scaled it. */
	radius: number;
	borderWidth: number;
	borderColor?: string;
	fill?: Array<[string, string]>;
	style?: ViewStyle | ViewStyle[];
};

/**
 * The brief's recurring plate: a vertical red gradient behind a gold-ish outline. RN has no
 * gradient view, so the fill is an SVG rect pinned under the content, the way DailyMissionRow
 * paints its claimable row.
 */
export const EventPanel = ({
	children,
	radius,
	borderWidth,
	borderColor = eventColors.panelBorder,
	fill = PANEL_FILL,
	style,
}: Props) => {
	const fillId = useSvgId('eventPanel');

	return (
		<View
			style={[
				styles.panel,
				eventGlow.panel,
				{ borderRadius: radius, borderWidth, borderColor },
				style,
			]}
		>
			<View pointerEvents='none' style={[styles.fill, { borderRadius: radius - borderWidth }]}>
				<Svg width='100%' height='100%'>
					<Defs>
						<LinearGradient id={fillId} x1='0' y1='0' x2='0' y2='1'>
							{fill.map(([offset, color]) => (
								<Stop key={offset} offset={offset} stopColor={color} />
							))}
						</LinearGradient>
					</Defs>
					<Rect x='0' y='0' width='100%' height='100%' fill={`url(#${fillId})`} />
				</Svg>
			</View>
			{children}
		</View>
	);
};

const styles = StyleSheet.create({
	panel: {
		backgroundColor: eventColors.surface,
		overflow: 'hidden',
	},
	fill: {
		...StyleSheet.absoluteFillObject,
		overflow: 'hidden',
	},
});

export default EventPanel;
